import { Page, Text, View, Document, StyleSheet ,Font ,Image} from '@react-pdf/renderer';
import React from 'react'
import LatoRegular from '../../../Assets/Fonts/Lato-Font/Lato-Regular.ttf';
import LatoBold from '../../../Assets/Fonts/Lato-Font/Lato-Bold.ttf';
import Header from "../Header";
import Footer from "../Footer";

Font.register({
    family: 'Lato',
    fonts: [
      { src: LatoRegular, fontWeight: 400 },
      { src: LatoBold , fontWeight: 700 }
    ]
});

  const styles = StyleSheet.create({
    pagewapper: {
        position: "relative",
        height: "100%"
    },
    content: {
        display: "flex",
        width: "570px",
        alignItems: "left"
    },
      contenttitle: {
        fontFamily: "Lato",
        fontWeight: 700,
        fontSize: "18px",
        lineHeight: "30px",
        color: "#426B88"
    },
    wapper: {
        width: "567px",
        fontFamily: "Lato",
        fontWeight: 400,
        fontSize: "12px",
        lineHeight: "18px",
        color: "#245775"
      },
      mainContent: {
          flexGrow: 1,
          marginTop:"28px",
    },
    footer: {
        marginTop: 'auto',
    },
    table: {
        width: '100%',
    },
    tableRow: {
        flexDirection: 'row',
        paddingVertical: 2,
        alignItems: 'center',
    },
      tableHeader: {
        paddingVertical: 1,
        fontWeight: 400,
        border:'0px',
        backgroundColor: '#245775',
        fontWeight: 'bold',
        color: 'white',
        borderTopLeftRadius: 4,
        borderTopRightRadius: 4,
      },
    headerCell:{color: 'white', fontWeight:400, paddingVertical:"5px"},
    cellQuestion: { width: '70%', fontSize: 10,color:"#394554", fontWeight:400},
    cellScore: { width: '7%', textAlign: 'center', fontSize: 10 },
    cell: {
        padding: "10px",
        textAlign: "left",
      },
      
      rowEven: {
        backgroundColor: "#F1F3F3",
      },
      rowOdd: {
        backgroundColor: "#FFF",
      },
      redRectangle: {
        width: 17,
        height: 17,
          backgroundColor: '#C99212',
        borderRadius:"1.34px",
    },
    goldRectangle: {
        width: 17,
        height: 17,
        backgroundColor: '#FFD700',
        borderRadius: "1.34px",
    },
      
  });

  const truncateText = (text, limit) => {
    if (text.length <= limit) return text;
    return text.substring(0, text.lastIndexOf(" ", limit)) + "...";
  };

  const getLastFilledIndex = (scores) => {
    for (let i = scores.length - 1; i >= 0; i--) {
      if (scores[i] === 1) return i;
    }
    return -1;
  };

  const renderRectangle = (score, index, scores) => {
    const lastFilledIndex = getLastFilledIndex(scores);
    return index <= lastFilledIndex ? <View style={styles.goldRectangle} /> : null;
  };

const PerformancePage = () => (
  <View style={styles.pagewapper}>
    <Header />
      <View style={styles.content}>
        <Text style={styles.contenttitle}>PERFORMANCE LEADERSHIP IN FOCUS</Text>
        <View style={styles.wapper}>
          <Text>This chart isolates the items related to the participant’s self-ranking in relation to the items measuring Performance Leadership. The response scale runs from 1 (Least) to 4 (Most). Any unselected statement will appear blank in the In Focus section.</Text>
        </View>         
      </View>
      <View style={styles.mainContent}>
        <View style={[styles.tableRow, styles.tableHeader]}>
          <Text style={[styles.cell, styles.cellQuestion, styles.headerCell]}>Strategic</Text>
            {[1, 2, 3, 4].map((num) => (
              <Text key={num} style={[styles.cell, styles.cellScore, styles.headerCell]}>
                {num}
              </Text>
            ))}
          </View>

          {data.map((item, index) => (
            <View key={index} style={[styles.tableRow, index % 2 === 0 ? styles.rowEven : styles.rowOdd]}>
              <Text style={[styles.cell, styles.cellQuestion]}>{truncateText(item.question, 80)}</Text>
              {item.scores.map((score, idx) => (
                <View key={idx} style={[styles.cell, styles.cellScore]}>
                  {renderRectangle(score, idx, item.scores)}
                </View>
              ))}
            </View>
          ))}
      </View>
    <Footer/>
  </View>
);

export default PerformancePage;


const data = [
    {
      "quadrant": "PERFORMANCE",
      "question": "When leading through conflict, my goal is to accomplish our objective by  any means necessary",
      "scores": [1, 1, 1, 1]
    },
    {
      "quadrant": "PERFORMANCE",
      "question": "I am at my best when I am driving others to deliver results.",
      "scores": [1, 1, 1, 1]
    },
    {
      "quadrant": "PERFORMANCE",
      "question": "I am motivated by achieving measurable and attainable goals.",
      "scores": [1, 1, 1, 1]
    },
    {
      "quadrant": "PERFORMANCE",
      "question": "I like the challenge of working in a high-performance leadership team.",
      "scores": [1, 1, 1, 1]
    },
    {
      "quadrant": "PERFORMANCE",
      "question": "I believe great execution is primary.",
      "scores": [1, 1, 1, 0]
    },
    {
      "quadrant": "PERFORMANCE",
      "question": "I am motivated to push my team to win.",
      "scores": [1, 1, 1, 0]
    },
    {
      "quadrant": "PERFORMANCE",
      "question": "I have found success by outworking other people.",
      "scores": [1, 1, 1, 0]
    },
    {
      "quadrant": "PERFORMANCE",
      "question": "I consider myself an action orientated manager who can drive objectives.",
      "scores": [1, 1, 0, 0]
    },
    {
      "quadrant": "PERFORMANCE",
      "question": "I pride myself on superior execution.",
      "scores": [1, 0, 0, 0]
    },
    {
      "quadrant": "PERFORMANCE",
      "question": "I like to win in a competitive environment.",
      "scores": [1, 0, 0, 0]
    },
    {
      "quadrant": "PERFORMANCE",
      "question": "I like to win in a competitive environment.",
      "scores": [1, 0, 0, 0]
    }
  ]
